'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M32 384c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64s-28.7-64-64-64c-5.9 0-11.6 .8-16.9 2.3-5.9 1.6-12.1-.2-16.2-4.8s-5.2-11-2.9-16.6c2.6-6.4 4-13.5 4-20.9 0-30.9-25.1-56-56-56-19.9 0-37.4 10.4-47.4 26.1-3.3 5.2-9.3 8.1-15.5 7.3s-11.3-5-13.3-10.8c-10.6-31.8-40.6-54.7-75.9-54.7-44.2 0-80 35.8-80 80 0 9.6 1.7 18.7 4.7 27.2 1.7 4.6 1.1 9.6-1.4 13.8s-6.8 6.9-11.6 7.5C56.3 324.6 32 351.5 32 384zM302.6 146.4c8.2-1.6 16.7-2.4 25.4-2.4 22.6 0 44 5.5 62.7 15.3 41.6-34.5 95-55.3 153.3-55.3l16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0c-47.2 0-90.8 15.7-125.7 42.3 18.1 16.1 31.9 37 39.4 60.6 23.5-19.3 53.5-30.9 86.3-30.9l16 0c8.8 0 16 7.2 16 16 0-69.3 0-138.7 0-208 0 8.8-7.2 16-16 16l-16 0c-97.3 0-184.1 44.5-241.4 114.4z', 'M302.6 146.4C359.8 76.6 446.7 32 544 32l16 0c8.8 0 16-7.2 16-16S568.8 0 560 0L544 0c-113.7 0-214.6 55.2-277.2 140.2 5.3 3.6 10.3 7.6 15.1 11.8 6.7-2.4 13.6-4.3 20.7-5.7zM485.6 257.9C502.3 246.6 522.4 240 544 240l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-32.8 0-62.8 11.6-86.3 30.9 .8 2.6 1.6 5.2 2.2 7.9 9 2.9 17.6 6.6 25.7 11.1zm-67.3-79.6C453.2 151.7 496.8 136 544 136l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-58.3 0-111.7 20.8-153.3 55.3 10 5.2 19.2 11.6 27.5 19zM96 272c0-44.2 35.8-80 80-80 35.3 0 65.3 22.9 75.9 54.7 2 5.9 7.1 10.1 13.3 10.8s12.2-2.1 15.5-7.3c9.9-15.7 27.5-26.1 47.4-26.1 30.9 0 56 25.1 56 56 0 7.4-1.4 14.4-4 20.9-2.3 5.6-1.1 12.1 2.9 16.6s10.3 6.4 16.2 4.8c5.4-1.5 11.1-2.3 16.9-2.3 35.3 0 64 28.7 64 64s-28.7 64-64 64L96 448c-35.3 0-64-28.7-64-64 0-32.5 24.3-59.4 55.7-63.5 4.8-.6 9.1-3.4 11.6-7.5s3-9.2 1.4-13.8C97.7 290.7 96 281.6 96 272zm80-112c-61.9 0-112 50.1-112 112 0 7.1 .7 14.1 1.9 20.8-38.3 12.6-65.9 48.7-65.9 91.2 0 53 43 96 96 96l320 0c53 0 96-43 96-96s-43-96-96-96l-.4 0c.2-2.6 .4-5.3 .4-8 0-48.6-39.4-88-88-88-21.7 0-41.5 7.9-56.9 20.9-19.8-31.7-55-52.9-95.1-52.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;